import {
  IPurchaseTransaction,
  TGetTransactionsData,
  TransactionTypeEnum
} from '@/services/types/TransactionData';

export const getTransaction = (transaction: TGetTransactionsData) => {
  switch (transaction.type) {
    case TransactionTypeEnum.Purchase: {
      const data = transaction.data as IPurchaseTransaction;
      return {
        icon: {
          iconUrl: data.place?.icon,
          baseColor: data.place?.baseColor
        },
        label: data.title
      };
    }
    case TransactionTypeEnum.Bank:
    case TransactionTypeEnum.Transfer:
    case TransactionTypeEnum.Admin:
    case TransactionTypeEnum.TopUp:
    case TransactionTypeEnum.EmergePay:
    default: {
      return {
        icon: null,
        label: transaction.data.title
      };
    }
  }
};
